/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import PropTypes from 'prop-types'

import './styles.css'

const Button = ({
  children,
  onClick,
  tabIndex,
  role,
  className,
  inverse,
  small,
}) => {
  const inverseClass = inverse ? 'inverse' : ''
  const smallClass = small ? 'small' : ''
  return (
    <a
      data-component="Button"
      role={role}
      className={`${className} ${inverseClass} ${smallClass}`}
      tabIndex={tabIndex}
      onClick={onClick}
    >
      {children}
    </a>
  )
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  role: PropTypes.string,
  tabIndex: PropTypes.number,
  inverse: PropTypes.bool,
  small: PropTypes.bool,
}

Button.defaultProps = {
  className: '',
  onClick: undefined,
  role: 'link',
  tabIndex: undefined,
  inverse: false,
  small: false,
}

export default Button



// WEBPACK FOOTER //
// ./src/components/_atoms/Button/index.js